"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function sum(arr) {
  return arr.reduce(function (prev, curr) {
    return prev + curr;
  }, 0);
}

function getFirstDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (var i = 0; i < args.length; i += 1) {
    if (typeof args[i] !== 'undefined') {
      return args[i];
    }
  }

  return undefined;
}

function getSizesForColumn(_ref, defaultFlex) {
  var columns = _ref.columns,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;

  if (columns) {
    columns.filter(function (col) {
      return col.show || col.visible;
    }).map(function (column) {
      return getSizesForColumn(column, defaultFlex);
    }).filter(Boolean);

    if (!columns.length) {
      return false;
    }

    var flex = sum(columns.map(function (col) {
      return col.flex;
    }));
    var newWidth = sum(columns.map(function (col) {
      return col.width;
    }));
    var newMaxWidth = sum(columns.map(function (col) {
      return col.maxWidth;
    }));
    return {
      flex: flex,
      newWidth: newWidth,
      newMaxWidth: newMaxWidth
    };
  }

  return {
    flex: width ? 0 : defaultFlex,
    width: width === 'auto' ? defaultFlex : getFirstDefined(width, minWidth, defaultFlex),
    maxWidth: maxWidth
  };
}

function getStylesForColumn(column, defaultFlex) {
  var _getSizesForColumn = getSizesForColumn(column, defaultFlex),
      flex = _getSizesForColumn.flex,
      width = _getSizesForColumn.width,
      maxWidth = _getSizesForColumn.maxWidth;

  return {
    flex: "".concat(flex, " 0 auto"),
    width: "".concat(width, "px"),
    maxWidth: "".concat(maxWidth, "px")
  };
}

var propTypes = {
  defaultFlex: _propTypes.default.number
};

var useMain = function useMain(props) {
  _propTypes.default.checkPropTypes(propTypes, props, 'property', 'useFlexLayout');

  var _props$defaultFlex = props.defaultFlex,
      defaultFlex = _props$defaultFlex === void 0 ? 1 : _props$defaultFlex,
      columns = props.columns,
      _props$hooks = props.hooks,
      getRowProps = _props$hooks.getRowProps,
      getHeaderGroupProps = _props$hooks.getHeaderGroupProps,
      getHeaderProps = _props$hooks.getHeaderProps,
      getCellProps = _props$hooks.getCellProps;
  var visibleColumns = columns.filter(function (column) {
    return column.visible;
  });
  var sumWidth = 0;
  visibleColumns.forEach(function (column) {
    var _getSizesForColumn2 = getSizesForColumn(column, defaultFlex),
        width = _getSizesForColumn2.width,
        minWidth = _getSizesForColumn2.minWidth;

    if (width) {
      sumWidth += width;
    } else if (minWidth) {
      sumWidth += minWidth;
    } else {
      sumWidth += defaultFlex;
    }
  });
  var rowStyles = {
    style: {
      display: 'flex',
      minWidth: "".concat(sumWidth, "px")
    }
  };
  getRowProps.push(function () {
    return rowStyles;
  });
  getHeaderGroupProps.push(function () {
    return rowStyles;
  });
  getHeaderProps.push(function (column) {
    return {
      style: _objectSpread({
        boxSizing: 'border-box'
      }, getStylesForColumn(column, defaultFlex))
    };
  });
  getCellProps.push(function (cell) {
    return {
      style: _objectSpread({}, getStylesForColumn(cell.column, defaultFlex))
    };
  });
  return props;
};

var useFlexLayout = function useFlexLayout(hooks) {
  hooks.useMain.push(useMain);
};

var _default = useFlexLayout;
exports.default = _default;